<oui-autocomplete
  #investisseurAutocomplete
  [label]="label"
  [control]="investisseurControl"
  [options]="investisseurAutocompleteOptions"
  [isLoading]="isInvestisseurLoading"
  [allowCustomValue]="true"
  class="width-100pc"></oui-autocomplete>
